<template>

  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting client time report...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <ClientTimeOrderedTile :hide-title='true' layout='bar' button-text="Reload Report"/>

        <v-layout row justify-end align-center class="mb-2">
          <v-flex shrink>
            <v-btn disabled @click="csvExport" color="primary" :disabled="loadingCsv" :loading="loadingCsv">
              <v-icon left small>
                save_alt
              </v-icon>
              Export
            </v-btn>
          </v-flex>
        </v-layout>

        <v-card>
          <v-card-title>
            <h1 class="subheading-1">Time Ordered by Client</h1>
          </v-card-title>

          <v-card-text>
            <h2 v-if="timePeriod === 'By Year'">For all {{ selectedClient.name }} locations between {{ startDate | moment("YYYY") }} and {{ endDate | moment("YYYY") }}</h2>
            <h2 v-else>For all {{ selectedClient.name }} locations between {{ startDate | moment("MMMM YYYY") }} and {{ endDate | moment("MMMM YYYY") }}</h2>

            <div class="mt-4">
              <table class="ordered-time">
                <tr>
                  <th>Time Period</th>
                  <th>Position</th>
                  <th>Shifts Ordered</th>
                  <th>Shifts Fulfilled</th>
                  <th>Shift Fulfillment Percent</th>
                  <th>Hours Ordered</th>
                  <th>Hours Fulfilled</th>
                  <th>Hours Fulfillment Percent</th>
                </tr>

                <tr v-for="total in totalMap">
                </tr>
                <tr v-for="periodAndPosition in timePeriodMap">
                  <td>
                    {{ periodAndPosition.time_period }}
                  </td>
                  <td>
                    {{ periodAndPosition.position_name }}
                  </td>
                  <td>
                    {{ periodAndPosition.shifts_ordered }}
                  </td>
                  <td>
                    {{ periodAndPosition.shifts_fulfilled }}
                  </td>
                  <td>
                    {{ periodAndPosition.shift_fulfillment_percent | decimalPlaces(2) }}%
                  </td>
                  <td>
                    {{ periodAndPosition.hours_ordered | decimalPlaces(2) }}
                  </td>
                  <td>
                    {{ periodAndPosition.hours_fulfilled | decimalPlaces(2) }}
                  </td>
                  <td>
                    {{ periodAndPosition.hours_fulfillment_percent | decimalPlaces(2) }}%
                  </td>
                </tr>
              </table>
            </div>
          </v-card-text>

        </v-card>
      </v-layout>

    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ExportToCsv } from 'export-to-csv';
import ClientTimeOrderedTile from '@/components/reports/client-time-ordered-tile.vue'

export default {
  components: {
    ClientTimeOrderedTile
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    //computedOffset: function () {
    //  return this.limit * (this.page - 1)
    //},
    //pageLength: function () {
    //  return Math.ceil(this.queryTotal / this.limit)
    //},
    formattedQuery: function () {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
        selectedClientId: this.selectedClientId,
        timePeriod: this.timePeriod,
      }
    },
    timePeriodMap: function () {
      if (!this.report) {
        return []
      }
      return this.report.byTimePeriod
    },

    totalMap: function () {
      if (!this.report) {
        return []
      }
      return this.report.totals
    },
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      startDate : '',
      endDate : '',
      selectedClientId : null,
      timePeriod: null,
      reportsPending: true,
      loadingCsv: false,
      selectedClient: {},
      report: null,
    }
  },

  methods: {
    setUp: function () {
      this.startDate = this.$route.query.startDate || this.startDate
      this.endDate = this.$route.query.endDate || this.endDate
      this.selectedClientId = parseInt(this.$route.query.selectedClientId)
      this.timePeriod = this.$route.query.timePeriod

      this.getReports()
    },

    generateCsv: function (report) {
      const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true, 
        showTitle: false,
        filename: `time-ordered_${ report.clientBusiness.name }_${ this.$moment(this.startDate).format('YYYY') }--${ this.$moment(this.endDate).format('YYYY') }`,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
      };

      const exportedFormat = report.report.byTimePeriod.map(r => {
        const row = {}

        row['Time Period'] = r.time_period
        row['Position'] = r.position_name
        row['Shifts Ordered'] = r.shifts_ordered
        row['Shifts Fulfilled'] = r.shifts_fulfilled
        row['Shift Fulfillment Percent'] = r.shift_fulfillment_percent
        row['Hours Ordered'] = r.hours_ordered
        row['Hours Fulfilled'] = r.hours_fulfilled
        row['Hours Fulfillment Percent'] = r.hours_fulfillment_percent

        return row
      })

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(exportedFormat);
      this.loadingCsv = false
    },

    round: function(hours) {
      return Math.round(hours * 100) / 100
    },

    csvExport: function () {
      this.loadingCsv = true
      this.$store.dispatch('reports/getClientTimeOrdered', this.formattedQuery)
      .then(report => {
        this.generateCsv(report)
      }).catch(err => {
        console.log(err)
      }).finally(res => {
        this.loadingCsv = false
      })
    },

    dateFormatted: function (date) {
      return date ? this.$moment(date).format('dddd, MMMM D') : ''
    },

    getReports: function () {
      this.reportsPending = true
      this.$store.dispatch('reports/getClientTimeOrdered', this.formattedQuery)
      .then(report => {
        this.report = report.report
        this.selectedClient = report.clientBusiness
      }).catch(err => {
        console.log(err)
      }).finally(res => {
        this.reportsPending = false
      })
    },
  },
}
</script>

<style scoped>
  table.ordered-time, table.ordered-time th, table.ordered-time td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  table.ordered-time th, table.ordered-time td {
    padding: 1em 2em;
  }
</style>
